import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";

export interface ListDividerProps extends React.HTMLAttributes<HTMLLIElement> {
  children?: React.ReactNode;
  className?: string;
  inset?: "none" | "gutter" | "decorator";
}

const DefaultStyle: React.CSSProperties = {
  // flex: 1,
  // height: 0,
  // borderTop: "1px solid var(--tea-color-border-primary)",
};

export const ListDivider = forwardRef(
  (
    {
      children,
      className,
      style,
      inset = "none",
      ...restProps
    }: ListDividerProps,
    ref: React.Ref<HTMLLIElement>
  ) => {
    const { classPrefix } = useConfig();
    return (
      <li
        className={classNames(`${classPrefix}-list__separate`, className, {
          "inset-gutter": inset === "gutter",
          "inset-decorator": inset === "decorator",
        })}
        style={{ ...DefaultStyle, ...style }}
        ref={ref}
        {...restProps}
      >
        {children}
      </li>
    );
  }
);

ListDivider.displayName = "ListDivider";
